export const chartColorPalettes = {
  overview: {
    light: ["#D09B52", "#9A7F78", "#3F6871", "#6A8193", "#2A3742"],
    dark: ["#F1C47E", "#C6A9A2", "#5C8A94", "#91A6B6", "#3B4C5A"],
  },
  marketing: {
    light: ["#6AA88B", "#A9785C", "#3A8C7D", "#586A50", "#C8BAA4"],
    dark: ["#A9D5B5", "#D8B595", "#5EB5A5", "#7A8E6F", "#F0E8D9"],
  },
  accounting: {
    light: ["#4F7A30", "#85B846", "#3B6323", "#9DB688", "#7C5B3D", "#589E6F", "#A47B62"],
    dark: ["#6EA743", "#A4D95E", "#4E8131", "#C2DBAA", "#9A7351", "#72C190", "#C0987C"],
  },
  managerial: {
    light: ["#9E6246", "#7D8B5C", "#6A7C91", "#A86E6B", "#4A4E2A", "#B2824C"],
    dark: ["#C97F5B", "#A6B57E", "#869BB5", "#C28784", "#656C3C", "#D89C61"],
  },
  sales: {
    light: [
      "#152D5D", // deep navy
      "#1B4F72", // navy-blue tint
      "#226079", // original
      "#2F6F8C", // dusty blue
      "#3A7C99", // teal-blue
      "#4095AF", // original
      "#5F8F99", // original
      "#6A9BA5", // toned teal
      "#7B6CA6", // original lavender
      "#8A82B2", // original
      "#96A0BE", // blue-grey tint
      "#A4B2CD", // washed blue
      "#B3C4DB", // soft periwinkle
      "#5A7FA3", // muted steel blue
      "#6D9CBD", // original
    ],
    dark: [
      "#1C3E79", // deep indigo
      "#24548A", // adjusted darker blue
      "#2D7C9F", // original
      "#3B8BAE", // ocean blue
      "#4C9DC2", // sky blue
      "#5ABEDC", // original
      "#6B9EC0", // original
      "#7DA7B3", // original
      "#89B5D6", // original
      "#9C8BC3", // original
      "#A79DCB", // original
      "#B2B0D3", // light lavender
      "#C0CBE1", // near-white blue
      "#8AA6C9", // steel purple
      "#7795B5", // greyed blue
    ],
  },
  customer: {
    light: ["#6A9CB3", "#3A393A", "#86756D", "#5F7D87", "#9B746B", "#4E6B79", "#7F8C8D"],
    dark: ["#A3C9DD", "#4D4B4C", "#A89C94", "#7E9AA5", "#C2A59E", "#708C9E", "#B2B0D3"],
  },
  // NEW PALETTES
  ecommerce: {
    light: [
      "#0066CC", // strong blue (2025 data) - high contrast
      "#FF6B35", // vibrant orange (2024 data) - high contrast
      "#FECA57", // sunny yellow 
      "#A29BFE", // lavender purple
      "#96CEB4", // mint green 
      "#FD79A8", // pink
      "#45B7D1", // sky blue 
      "#D4A574", // warm gold 
      "#6C5CE7", // royal purple
      "#FF9FF3", // soft magenta 
      "#74B9FF", // bright blue  
      "#FDCB6E", // orange yellow
    ],
    dark: [
      "#3399FF", // bright blue (2025 data) - high contrast in dark mode
      "#FF8A5C", // enhanced orange (2024 data) - high contrast in dark mode
      "#FFD93D", // enhanced yellow
      "#B2A9FF", // lighter lavender  
      "#A8D8C4", // lighter mint
      "#FF89B5", // enhanced pink
      "#54C7E8", // brighter sky blue
      "#E8BE89", // lighter gold
      "#7C6CFA", // enhanced purple
      "#FFADFF", // brighter magenta
      "#82C9FF", // enhanced blue
      "#FFD584", // lighter orange
    ],
  },
  wholesale: {
    light: [
      "#2C3E50", // deep slate 
      "#1ABC9C", // professional teal 
      "#E67E22", // business orange
      "#9B59B6", // professional purple
      "#2ECC71", // success green
      "#7F8C8D", // steel grey 
      "#3498DB", // corporate blue
      "#D35400", // burnt orange
      "#27AE60", // forest green
      "#34495E", // dark grey blue 
      "#2980B9", // deeper blue
      "#8E44AD", // deep purple
      "#16A085", // darker teal
      "#95A5A6", // lighter grey 
      "#BDC3C7", // silver 
    ],
    dark: [
      "#34495E", // lighter slate
      "#26D0CE", // brighter teal
      "#FDCB6E", // brighter orange
      "#A29BFE", // brighter purple
      "#55EFC4", // brighter success green 
      "#8A979A", // lighter steel
      "#74B9FF", // brighter corporate blue
      "#E17055", // enhanced burnt orange
      "#48CAE4", // enhanced forest green
      "#415A77", // enhanced grey blue
      "#0984E3", // enhanced deep blue
      "#6C5CE7", // enhanced deep purple
      "#1DD1A1", // enhanced operations teal
      "#A8B5B8", // enhanced grey
      "#CDD6DA", // lighter silver
    ],
  },
  retail: {
    light: [
      "#0066CC", // strong blue (2025 data) - high contrast
      "#FF6B35", // vibrant orange (2024 data) - high contrast
      "#DAA520", // golden rod (premium displays)
      "#4682B4", // steel blue (modern retail)
      "#8B4513", // saddle brown (leather goods)
      "#708090", // slate grey (neutral backgrounds)
      "#CD853F", // peru (warm wood tones)
      "#5F9EA0", // cadet blue (cool displays)
      "#A0522D", // sienna (earth tones)
      "#6B8E23", // olive drab (natural products)
      "#4169E1", // royal blue (electronics sections)
      "#8B008B", // dark magenta (fashion accent)
      "#FF8C00", // dark orange (sale tags)
      "#556B2F", // dark olive green (organic section)
      "#483D8B", // dark slate blue (luxury section)
    ],
    dark: [
      "#3399FF", // bright blue (2025 data) - high contrast in dark mode
      "#FF8A5C", // enhanced orange (2024 data) - high contrast in dark mode
      "#FFD700", // gold (enhanced golden rod)
      "#87CEEB", // sky blue (enhanced steel blue)
      "#DEB887", // burlywood (enhanced brown)
      "#778899", // light slate grey (enhanced)
      "#F4A460", // sandy brown (enhanced peru)
      "#20B2AA", // light sea green (enhanced cadet)
      "#CD853F", // peru (enhanced sienna)
      "#9ACD32", // yellow green (enhanced olive)
      "#6495ED", // cornflower blue (enhanced royal)
      "#DA70D6", // orchid (enhanced magenta)
      "#FFA500", // orange (enhanced dark orange)
      "#8FBC8F", // dark sea green (enhanced olive)
      "#9370DB", // medium purple (enhanced slate blue)
    ],
  },
};